<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :bgColor="bgColor"
            :icons="icon_data"
            :load_url="load_url"
            :base-col-len="12"
            :hasLinks="hasLinks"
            :title="title">
    </DashboardCard>
</template>
<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'GeneralFlags',
        components: {DashboardCard},
        props: {
            dataDisplay: {type:String, default: null},
            bgColor: {type: String, default: 'light'},
            width: {type: Number, default: 25}
        },
        data() {
            return {
                hasLinks: true,
                main_icon: 'fa-light fa-flag',
                color: '#5bc0de',
                title: 'General Flags',
                load_url: '/dashboards/GeneralFlags',
                icon_data: [
                    {
                        name: 'Follow-up',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=1',
                        text_color: '#555'
                    },
                    {
                        name: 'Technology Issue',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=24',
                        text_color: '#555'
                    },
                    // {
                    //     name: 'Banned Customer',
                    //     url: '/search?filterField_0=flag_type_id&filterModel_0=customer_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=36',
                    //     text_color: '#555'
                    // },
                ],
            };
        },
    };
</script>

<style scoped>

</style>